import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Database, get, ref, set } from '@angular/fire/database';
import { getActualLan } from '@contler/translate/utils';
import { API_URL, AuthHttpHandleService } from '@contler/utils';
import { TranslateService } from '@ngx-translate/core';
import { Observable, from } from 'rxjs';

import { LANGUAGES } from '../constants';
import { getFireLoc } from '../utils/get-language';

@Injectable({
  providedIn: 'root',
})
export class DynamicTranslateService {
  private http: HttpClient;
  private db = inject(Database);
  private authHandle = inject(AuthHttpHandleService);
  private apiUrl = inject(API_URL);
  private translateService = inject(TranslateService);

  constructor() {
    this.http = new HttpClient(this.authHandle);
  }

  generateTranslate(hotel: string, url: string, mgs: string) {
    const actualLang = getFireLoc(this.translateService.getDefaultLang());
    const lang = LANGUAGES.find((lan) => lan.prefix === actualLang);
    const otherLang = LANGUAGES.filter((lan) => lan.prefix !== actualLang);

    const urlService = new URL(`/translate`, this.apiUrl);

    return this.http.post<{ key: string }>(urlService.toString(), {
      actualLan: lang,
      languages: otherLang,
      hotel,
      url,
      mgs,
    });
  }

  changeTranslation(key: string, languagePrefix: string, newText: string, hotelId: string) {
    const translationRef = ref(this.db, `dictionary/${hotelId}/${key}/${languagePrefix}`);
    return set(translationRef, newText);
  }

  getTranslate(hotelId: string, key: string, language?: string | undefined): Observable<string> {
    const lang = language ?? getFireLoc(this.translateService.currentLang ?? getActualLan());
    const refT = ref(this.db, `dictionary/${hotelId}/${key}/${lang}`);
    return from(get(refT).then((snap) => snap.val() || key));
  }

  /**
   * Translates text to multiple languages using the basic translation endpoint
   * @param text - The text to translate
   * @returns Observable with array of translation results containing language and translation
   */
  translateBasic(text: string): Observable<Array<{ language: string; translation: string }>> {
    const actualLang = getFireLoc(this.translateService.getDefaultLang());
    const lang = LANGUAGES.find((lan) => lan.prefix === actualLang);
    const otherLang = LANGUAGES.filter((lan) => lan.prefix !== actualLang);

    const urlService = new URL(`/translate/basic`, this.apiUrl);

    return this.http.post<Array<{ language: string; translation: string }>>(urlService.toString(), {
      from: otherLang,
      to: lang,
      msg: text,
    });
  }
}
